{
  "rowTypeName": {
    "companies": "Entreprises",
    "contacts": "Contacts",
    "key_activities": "Activités clés",
    "projects_opportunities": "Opportunités de projets",
    "opportunities": "Opportunités",
    "generic_items": "Éléments",
    "key_activity_dashboard": "Activités clés"
  },
  "actions": {
    "add_opportunity": "Créer une opportunité",
    "add_activity": "Créer une activité",
    "add_company": "Ajouter une entreprise",
    "add_contact": "Ajouter un contact",
    "add_generic_item": "Créer un élément",
    "bulk_edit": "Modification en masse",
    "bulk_edit_aria_label": "Modifier en masse les éléments sélectionnés",
    "add_to_list": "Ajouter à la liste",
    "bulk_add_to_list_aria_label": "Ajouter les éléments sélectionnés à la liste",
    "bulk_remove_aria_label": "Supprimer en masse les éléments sélectionnés",
    "edit_custom_field_header": "Modifier les champs personnalisés"
  },
  "view_types": {
    "list": "Vue Liste",
    "kanban": "Vue Kanban",
    "calendar": "Vue Calendrier",
    "timeline": "Vue Chronologie"
  },
  "list_types": {
    "basic": "Basique",
    "large": "Grande"
  },
  "share": {
    "invite_member": "Inviter un Membre"
  },
  "views": {
    "views": "Vues",
    "delete_view": {
      "title": "Supprimer la vue",
      "label": "Supprimer la vue {{viewName}}",
      "confirm_title": "Êtes-vous sûr ?",
      "confirm_content": "Cliquez sur confirmer pour supprimer la vue"
    },
    "actions": "Actions pour la vue {{viewName}}",
    "default_view": "Vue par défaut",
    "create_view": "Créer une vue",
    "edit_view": {
      "title": "Modifier la vue",
      "label": "Modifier la vue {{viewName}}"
    },
    "share": {
      "title": "Partager la Vue",
      "label": "Partager la vue {{viewName}}",
      "success_message": "La vue de liste a été partagée avec succès. Nous informerons les destinataires."
    }
  },
  "bulk_actions": {
    "confirm_title": "Êtes-vous sûr ?",
    "confirm_content": "Les {{rowTypeName}} seront supprimés de cette liste."
  },
  "inline_actions": {
    "edit_custom_field": "Modifier le champ personnalisé",
    "remove": "Supprimer"
  },
  "more_actions": {
    "more": "Plus",
    "removed_history": "Historique supprimé",
    "list_settings": "Paramètres de liste",
    "large_list_view_title": "Vue de liste large",
    "large_list_view_description": "Améliore les performances, limite la recherche, le tri et les filtres.",
    "switch_list_type": "Passer à la vue de liste {{listType}}",
    "switch_list_type_loading": "Chargement de la table..."
  },
  "export": {
    "title": "Exporter",
    "confirmationModal": {
      "content": "L'exportation d'une grande liste inclura tous les {{rowTypeName}} et peut prendre du temps. Pour accélérer le processus, envisagez d'appliquer un filtre. Êtes-vous sûr de vouloir procéder à l'exportation de tous les {{rowTypeName}} sans aucun filtre ?"
    }
  },
  "form": {
    "placeholder": "Taper et appuyer sur Entrée",
    "searching": "Recherche...",
    "start_typing_search": "Commencer à taper pour rechercher"
  },
  "grid": {
    "columns": "Colonnes"
  },
  "rollup_fields": {
    "empty_state": {
      "title": "Aucun champ de cumul pour le moment",
      "description": "Pour commencer, ajoutez un champ de cumul pour agréger et afficher les informations les plus pertinentes pour votre flux de travail"
    },
    "modal": {
      "header": "Champs de cumul",
      "caption": "Le champ de cumul vous permet d'agréger les données des éléments liés dans une vue unique."
    },
    "actions": {
      "rename_tooltip": "Renommer",
      "delete_tooltip": "Supprimer",
      "rename_aria_label": "Renommer le champ de cumul {{name}}",
      "delete_aria_label": "Supprimer le champ de cumul {{name}}"
    },
    "delete": {
      "confirm_title": "Êtes-vous sûr?",
      "confirm_content": "Cliquez sur confirmer pour supprimer ce champ de cumul"
    },
    "update": {
      "modal_header": "Renommer le champ de cumul",
      "name_label": "Nom du cumul",
      "validation_required": "Veuillez saisir le nom du champ de cumul"
    },
    "create": {
      "button_text": "Ajouter un cumul",
      "modal_header": "Ajouter un cumul",
      "modal_caption": "Utilisez le cumul pour agréger les informations des colonnes liées. En savoir plus",
      "name_label": "Nom du cumul",
      "source_label": "Source",
      "source_field_aria_label": "Sélectionner la liste source",
      "source_field_placeholder": "Saisir pour rechercher une liste",
      "conditions_label": "Appliquer en fonction des conditions",
      "conditions_tooltip": "Seules les lignes qui répondent à vos critères sélectionnés seront incluses.",
      "validation_name_required": "Veuillez saisir le nom du champ de cumul",
      "validation_source_required": "Veuillez sélectionner une liste source",
      "validation_operation_required": "Le type d'opération est requis"
    },
    "source": {
      "opportunities": "Opportunités"
    },
    "table": {
      "columns": {
        "rollup_field_name": "Nom du champ de cumul",
        "source": "Source",
        "column_field": "Champ de colonne",
        "operation": "Opération",
        "condition": "Condition",
        "value": "Valeur",
        "actions": "Actions"
      }
    }
  }
}
